import { type RootState } from '../store'
import { type AuthResponse } from '../user/user.type'

export const authSelector = (state: RootState): AuthResponse => state.auth
